/* hs-eslint ignored failing-rules */

'use es6';

import I18n from 'I18n';
import { patchForm } from 'FormsUI/api/LeadFlows';
import PublishState from 'FormsUI/constants/PublishState';
import { updateCRMObjectPublishState } from 'FormsUI/components/dashboard/frameworkTable/utils';
import listingLibObserver from 'framework-listing-lib/utils/listingLibObserver';
function createAction(name) {
  return `@@leadFlows/${name}`;
}
export const REQUEST_LEADFLOW_DEFINITION = createAction('REQUEST_LEADFLOW_DEFINITION');
export const SUCCEED_REQUESTING_LEADFLOW_DEFINITION = createAction('SUCCEED_REQUESTING_LEADFLOW_DEFINITION');
export const FAILED_REQUESTING_LEADFLOW_DEFINITION = createAction('FAILED_REQUESTING_LEADFLOW_DEFINITION');
const REQUEST_UNPUBLISH_FORM = createAction('REQUEST_UNPUBLISH_FORM');
const SUCCEED_UNPUBLISH_FORM = createAction('SUCCEED_UNPUBLISH_FORM');
const FAILED_UNPUBLISH_FORM = createAction('FAILED_UNPUBLISH_FORM');
const requestUnpublishForm = () => ({
  type: REQUEST_UNPUBLISH_FORM
});
export const succeededUnpublishForm = () => ({
  type: SUCCEED_UNPUBLISH_FORM,
  meta: {
    notification: {
      type: 'success',
      message: I18n.text('editor.form.unpublishSuccess')
    }
  }
});
const failedUnpublishForm = () => ({
  type: FAILED_UNPUBLISH_FORM,
  meta: {
    notification: {
      type: 'danger',
      title: I18n.text('editor.form.unpublishError.header'),
      message: I18n.text('editor.form.unpublishError.message')
    }
  }
});
export function unpublishForm(guid, crmObject) {
  return dispatch => {
    dispatch(requestUnpublishForm());
    patchForm(guid, {
      enabled: false
    }).then(() => {
      const updatedCrmObject = updateCRMObjectPublishState(crmObject, PublishState.DRAFT);
      listingLibObserver.update(updatedCrmObject);
      dispatch(succeededUnpublishForm());
    }).catch(dispatch.bind(null, failedUnpublishForm()));
  };
}